export default (theme) => {
    return {
        root: {
            outline: 'none',
        },
        inputWrapper: {},
        fieldBottom: {},
        Label: {
            width: 180,
            marginRight: 17,
            padding: '0 0 8px 0',
            flexShrink: 0,
        },
        vertical: {
            '& $inputWrapper': {
                display: 'block',
                padding: '8px 0',
                marginLeft: '0 !important',
                '& $Label': {
                    width: '100%',
                },
            },
        },
        horizontal: {
            '& $fieldBottom': { marginTop: 5 },
            '& $inputWrapper': {
                display: 'flex',
                alignItems: 'flex-start',
                padding: '8px 0',
                width: '100%',
                minWidth: 0,
                '& $formControl': {
                    alignItems: 'stretch',
                    flex: 1,
                    flexDirection: 'column',
                    width: 'auto',
                    minWidth: 0,
                    '& > *': { maxWidth: '100%' },
                },
                '& $error': {},
                '& $Label': {
                    padding: 0,
                    paddingTop: 8,
                },
            },
        },
        formControl: {
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            width: 320,
            boxSizing: 'border-box',
            minWidth: 0,
        },
        isFullWidth: {
            '& $formControl': {
                width: '100%',
            },
            '&$vertical $Label': {
                width: '100%',
            },
            '&$horizontal $formControl': {
                flex: 1,
                width: 'auto',
            },
        },
        error: {},
    };
};
